import { da } from 'date-fns/locale';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import styled, { createGlobalStyle } from 'styled-components';
import { buttonStyling } from '../button/Shared';
import { colors } from '../colors/color';
import { getIconSvg, Icon, iconName } from '../icons/Icons';
import { defaultInputWrapperCss, disabledInputWrapperCss, errorStateInputWrapperCss, inputBorderRadius, noHoverdefaultInputWrapperCss } from './sharedContainerStyles';
import { textInputPadding } from './TextInput';


export const DateInputGlobalStyle = createGlobalStyle`
    .react-datepicker-popper {
        z-index: 1000;
    }
`;

export type DateInputProps = {
    id?: string,
    value: Date | null,
    onValueChange: (value: Date | null) => void,
    disabled?: boolean,
    inErrorState?:boolean,
    placeHolder?: string,
    width?:string,
    showClearButton?: boolean,
    noBorder?: boolean,
    noIcon?:boolean,
    fontSize?: 14 | 16,
    icon?: iconName,
    
}
export function DateInput(props: DateInputProps) {

    const handleChange = (date: Date | undefined | null) => {
        const valueDate = date || null;
        props.onValueChange(valueDate);
    }

    const disabled = props.disabled === undefined ? false : props.disabled;
    const inErrorState = props.inErrorState === undefined ? false : props.inErrorState;
    const { paddingVertical, paddingHorizontal } = textInputPadding(props.fontSize);

    return (
        <MasterWrapper wrapperWidth={props.width || '150px'}>
            <DateTimeWrapper disabled={disabled} inErrorState={inErrorState} noBorder={props.noBorder===true} fontSize={props.fontSize || 16} paddingVertical={paddingVertical} paddingHorizontal={paddingHorizontal}>
                <DatePicker
                    id={props.id}
                    dateFormat="dd/MM/yyyy"
                    selected={props.value || undefined}
                    onChange={handleChange}
                    disabled={props.disabled}
                    locale={da}
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }}
                    popperProps={{
                        strategy: 'fixed' as const
                      }}
                    placeholderText={props.placeHolder} />
                {props.noIcon !== true &&
                    <DateTimeIconContainer disabled={disabled} inErrorState={inErrorState} noBorder={props.noBorder===true}>
                        {props.icon ? getIconSvg(props.icon) : getIconSvg("calendar")}
                    </DateTimeIconContainer>
                }
            </DateTimeWrapper>
            {props.showClearButton && (props.disabled===undefined || props.disabled===false) &&
                <ButtonRow>

                    <CancelButton
                        tabIndex={1}
                        onClick={() => props.onValueChange(null)}>
                        <Icon name={"actions_close"} size={"small"} />
                    </CancelButton>

                </ButtonRow>
            }
            <DateInputGlobalStyle />
        </MasterWrapper>
    );
}

const ButtonRow = styled.div`
    position:absolute;
    z-index: 1000;
    display: block;
    width: 100%;
    text-align: right;
    pointer-events: none;
    & > button {
        margin-left:5px;
        pointer-events: auto;
    }
    visibility: hidden;
`;

export const MasterWrapper = styled.div<{wrapperWidth:string}>`
    position: relative;
    display:${props => props.wrapperWidth === '100%' ? 'block' : 'inline-block'};
    width:${props => props.wrapperWidth} !important;
    margin-right:${props => props.wrapperWidth === '100%' ? '0px' : '5px'};
    
    &:hover ${ButtonRow} {
        visibility:visible;
    }
`;

export const DateTimeWrapper = styled.div<{disabled:boolean, inErrorState:boolean, noBorder:boolean, fontSize:number, paddingVertical:number, paddingHorizontal:number}>`
    width:100%;
    display:flex;
    flex-direction: row;
    align-content: stretch;
    gap:0;
    border-radius: ${inputBorderRadius};
    
    & > div:first-child{
        flex:1;
    }
    & input {
        cursor: ${props => props.disabled ? 'default' : 'pointer'};
        font-family: "Noto Sans", sans-serif;
        font-weight: 400;
        width:100%;
        font-size: ${props => props.fontSize}px;
        line-height: 18px;
        background: transparent;
        outline: none;
        border:none;
        padding: ${props => props.paddingVertical}px ${props => props.paddingHorizontal}px;
    }
    ${props => {

        if(props.disabled){
            if(props.noBorder)
                return noHoverdefaultInputWrapperCss;
            else
                return disabledInputWrapperCss;
        }
        else {
            return props.inErrorState ? errorStateInputWrapperCss : defaultInputWrapperCss;
        }
    }}

    ${props => props.noBorder && 'border:1px solid #fff;' }
`;

type DateInputIconProps = {
    disabled: boolean,
    inErrorState: boolean,
    noBorder: boolean
}

const getFillColor = (props: DateInputIconProps) => {
    switch (true) {
        case props.inErrorState:
            return colors.icon.error;
        case props.disabled:
            return props.noBorder ? colors.icon.default : colors.icon.passive;
        default:
            return colors.icon.default;
    }
};

export const DateTimeIconContainer = styled.div<DateInputIconProps>`
    flex: 0 0 22px;
    height:22px;
    align-self: center;
    justify-self: end;
    &:last-child {
        margin-right:5px;
    }
    & > svg {
        padding:0px;
        display: block;
        width:22px;
        height:22px;
        fill: ${props => getFillColor(props)};
    }
`;

export const CancelButton = styled.button`
    border: ${props => buttonStyling(props.theme.colors).handleButtonBorder('outlined')};
    border-radius: 4px;
    padding:2px;
    background-color: ${props => buttonStyling(props.theme.colors).handleButtonBackground('outlined')};
    & svg {
        fill:${props => buttonStyling(props.theme.colors).handleButtonColor('outlined')};
    }
    cursor: pointer;
`;